// @flow

import type { CardSummary } from './card-summary'
import type { ReplacementCard } from './replacement-card'
import { buildCardSummary } from './card-summary'
import type {CardType} from './card-type'

export type CardDetails =
  CardSummary &
  {
    contractNumber: ?number,
    expirationDate: ?Date,
    cardType: ?CardType,
    replacementCard: ?ReplacementCard,
  }

const buildCardDetails = (): CardDetails => {
  const cardDetails = ({
    ...buildCardSummary(),
    contractNumber: null,
    expirationDate: null,
    cardType: null,
    replacementCard: null
  }: CardDetails)
  return cardDetails
}

export {
  buildCardDetails
}



// WEBPACK FOOTER //
// ./src/types/card-details.js